import { render } from "./VDropdown.vue?vue&type=template&id=5690fc4a&scoped=true"
import script from "./VDropdown.vue?vue&type=script&lang=js"
export * from "./VDropdown.vue?vue&type=script&lang=js"

import "./VDropdown.vue?vue&type=style&index=0&id=5690fc4a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5690fc4a"]])

export default __exports__